<template>
    <v-content>
        <v-row class="pb-0 pb-sm-10">
            <v-col class="display-1">
                {{ action === "update" ? "Редактирование настроек" : "Создание настроек" }}
            </v-col>
            <v-col>
                <div class="float-right">
                    <v-btn color="info" depressed @click="back()">
                        Назад
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="5" class="pa-4">
                <div class="w100">
                    <p class="text-field-header">Название:</p>
                    <v-text-field
                        outlined
                        label="Название"
                        v-model="settings.name"
                    ></v-text-field>
                </div>
            </v-col>
            <v-col cols="5" class="pa-4">
                <div class="w100">
                    <p class="text-field-header">Описание:</p>
                    <v-textarea
                        outlined
                        label="Описание"
                        v-model="settings.description"
                    ></v-textarea>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="5" class="pa-4">
                <div class="w100">
                    <p class="text-field-header">Количество дней для обновления пользователя:</p>
                    <v-text-field
                        outlined
                        label="Количество дней"
                        v-model="settings.hours_refresh_user"
                    ></v-text-field>
                </div>
            </v-col>
            <v-col cols="5" class="pa-4">
                <div class="w100">
                    <p class="text-field-header">Максимальное количество воркеров:</p>
                    <v-text-field
                        outlined
                        label="Максимальное количество воркеров"
                        v-model="settings.max_workers"
                    ></v-text-field>
                </div>
            </v-col>
        </v-row>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
                <v-row no-gutters>
                  <v-col class="d-flex justify-start" cols="4">
                    Настройки уведомлений
                  </v-col>
                </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-row>
                    <v-col cols="5" class="pa-4">
                        <div class="w100">
                            <p class="text-field-header">Blacklist СМС</p>
                            <v-text-field
                                outlined
                                label="Бан СМС"
                                v-model="settings.count_sms_ban"
                            ></v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="5" class="pa-4">
                        <div class="w100">
                            <p class="text-field-header">Blacklist Звонки</p>
                            <v-text-field
                                outlined
                                label="Бан ЗВОНКОВ"
                                v-model="settings.count_call_ban"
                            ></v-text-field>
                        </div>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                    <v-col cols="5" class="pa-4">
                        <div class="w100">
                            <p class="text-field-header">Whitelist СМС</p>
                            <v-text-field
                                outlined
                                label="Whitelist СМС"
                                v-model="settings.count_sms_white"
                            ></v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="5" class="pa-4">
                        <div class="w100">
                            <p class="text-field-header">Whitelist Звонки</p>
                            <v-text-field
                                outlined
                                label="Whitelist ЗВОНКОВ"
                                v-model="settings.count_call_white"
                            ></v-text-field>
                        </div>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                    <v-col>
                        <div class="w100">
                            <p class="text-field-header">Работает отправка смс в цепочке?:</p>
                            <v-switch small v-model="settings.sms_chain_is_sending"></v-switch>
                        </div>
                    </v-col>
                    <v-col>
                        <div class="w100">
                            <p class="text-field-header">Работает отправка звонков в цепочке?:</p>
                            <v-switch small v-model="settings.call_chain_is_sending"></v-switch>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <div class="w100">
                            <p class="text-field-header">Работает отправка смс в instant?:</p>
                            <v-switch small v-model="settings.sms_instant_is_sending"></v-switch>
                        </div>
                    </v-col>
                    <v-col>
                        <div class="w100">
                            <p class="text-field-header">Работает отправка звонков в instant?:</p>
                            <v-switch small v-model="settings.call_instant_is_sending"></v-switch>
                        </div>
                    </v-col>
                </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel style="margin-top:10px">
            <v-expansion-panel-header>
                <v-row no-gutters>
                  <v-col class="d-flex justify-start" cols="4">
                    Настройки VK API
                  </v-col>
                </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-row>
                    <v-col>
                        <div class="w100">
                            <p class="text-field-header">Выгружаем пользователей из VK?:</p>
                            <v-switch small v-model="settings.isVKApiUsed"></v-switch>
                        </div>
                    </v-col>
                    <v-col>
                        <div class="float-right" v-if="settings.isVKApiInfoSaved">
                            <v-btn color="info" depressed @click="saveVkInfo()">
                                Обновить
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <div v-if="settings.isVKApiUsed">
                    <v-row v-if="!settings.isVKApiInfoSaved">
                        <v-col cols="5" class="pa-4">
                            <v-row>
                                <div class="w100">
                                    <p class="text-field-header">Api ключ из конструктора</p>
                                    <v-text-field
                                        outlined
                                        label="Api key"
                                        v-model="settings.vk_api_key"
                                    ></v-text-field>
                                </div>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row v-for="vkInfo in vkInfos" v-if="settings.isVKApiInfoSaved">
                        <v-col cols="5" class="pa-4">
                            <v-row>
                                <div class="w100">
                                    <p class="text-field-header">Имя:</p>
                                    <v-text-field
                                        outlined
                                        label="Имя"
                                        v-model="vkInfo.name"
                                        disabled
                                    ></v-text-field>
                                </div>
                            </v-row>
                        </v-col>
                        <v-col cols="5" class="pa-4">
                            <v-row>
                                <div class="w100">
                                    <p class="text-field-header">Лид формы:</p>
                                    <v-data-table :headers="headers" :items="vkInfo.accounts" class="elevation-4">
                                        <template v-slot:item.isUsed="{ item }">
                                            <v-switch small v-model="item.isUsed" @change="changeUsage(item.id)"></v-switch>
                                        </template>
                                    </v-data-table>
                                </div>
                            </v-row>
                        </v-col>
                    </v-row>
                </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel style="margin-top:10px">
            <v-expansion-panel-header>
                <v-row no-gutters>
                  <v-col class="d-flex justify-start" cols="4">
                    Настройки работы с API
                  </v-col>
                </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-row>
                    <v-col cols="5" class="pa-4">
                        <div class="w100">
                            <p class="text-field-header">Ключ API</p>
                            <v-text-field
                                outlined
                                disabled
                                label="Бан СМС"
                                v-model="authUser.api_key"
                            ></v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="3" class="pa-4">
                        <div style="margin-top:5px">
                            <v-btn color="primary" depressed @click="updateApiKey()">
                                Обновить API ключ
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-col>
            <div class="float-right">
                <v-btn color="primary" depressed @click="saveSettings()">
                    <v-icon small>mdi-plus</v-icon>
                    Сохранить
                </v-btn>
            </div>
        </v-col>
        <OverlayLoader :show="isLoading"></OverlayLoader>
    </v-content>
</template>

<script>
import OverlayLoader from "@/app/shared/components/app-loader/Loader";

export default {
    name: "AdminUpdateSettings",
    components: {
        OverlayLoader,
    },
    data() {
        return {
            headers: [
                { text: "Используем?", sortable: true, value: "isUsed" },
                { text: "Имя клиента", sortable: true, value: "token_name" },
                { text: "Имя формы", sortable: false, value: "form_name" },
            ],
        };
    },
    created() {
        if (this.action == "update") {
            this.$store.dispatch("GET_SETTINGS_BY_ID", this.settingsId);
            this.$store.dispatch("GET_VK_INFO_BY_ID", this.settingsId);
        }
        this.$store.dispatch('GET_MAILING_ACCOUNT_LIST', {is_used: true});
    },
    computed: {
        settingsId() {
            return this.$route.params.id;
        },
        action() {
            return this.$route.name == "UpdateSettings" && this.settingsId ? "update" : "create";
        },
        settings() {
            return this.$store.getters.CURRENT_SETTINGS;
        },
        authUser() {
            return this.$store.getters.AUTH_USER;
        },
        vkInfos() {
            return this.$store.getters.VK_INFOS;
        },
        isLoading() {
            return this.$store.getters.CURRENT_SETTINGS_LOADING;
        },
        mailing_accounts() {
            return this.$store.getters.MAILING_ACCOUNTS_LIST.results;
        },
    },
    methods: {
        saveSettings() {
            const action_path = this.action === "create" ? "CREATE_SETTINGS": "UPDATE_SETTINGS";
            this.$store
                .dispatch(action_path, this.settings)
                .then(() => {
                    this.$toast.success("Настройки сохранены");
                    this.back();
                })
                .catch(() => {
                    this.$toaster.error("Неизвестная ошибка!");
                });
        },
        saveVkInfo() {
            this.$store
                .dispatch("UPDATE_VK_SETTINGS", this.settings.id)
                .then(() => {
                    this.$toast.success("Настройки изменены");
                })
                .catch(() => {
                    this.$toast.error("Неизвестная ошибка!");
                });
        },
        changeUsage(id) {
            this.$store
                .dispatch("CHANGE_USAGE", id)
                .then(() => {})
                .catch(() => {
                    this.$toast.error("Неизвестная ошибка!");
                });
        },
        filteredDataArray(data, item, type_of_notification) {
            return data.filter((option) => {
              return option.name
                  .toString()
                  .toLowerCase()
                  .indexOf(item.name.toLowerCase()) >= 0 && option.type_of_notification === type_of_notification && option.is_used;
            });
        },
        back() {
            this.$router.push({ name: "AdminSettings" });
        },
        updateApiKey() {
            this.$store.dispatch("UPDATE_API_KEY")
                .then(() => {
                    this.$toast.success("API ключ обновлен");
                })
                .catch(() => {
                    this.$toast.error("Неизвестная ошибка!");
                });
        },
        generateDocs() {
            this.$store.dispatch("GENERATE_DOCS")
            .then((data) => {
                    const url = window.URL.createObjectURL(new Blob([data.data]));
                    const link = document.createElement('a');
                    link.href = url;

                    const fileName = this.authUser.api_key + '.docx';

                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    this.$toast.success('Документация сгенерирована');
                })
                .catch((error) => {
                    if (error.response.data.message === 'Empty result') {
                        this.$toast.error("Пустой набор данных");
                    }
                    else {
                        this.$toast.error("Неизвестная ошибка!");
                    }
                });

        },
    },
};
</script>

<style></style>
